import React from 'react';

function Caret({ className, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="41"
      height="41"
      viewBox="0 0 41 41"
      className={className}
      {...props}
    >
      <path
        fill="#323232"
        d="M1.834 11a1.17 1.17 0 00-.826 2l7.535 7.541a1.174 1.174 0 001.658 0L17.736 13a1.17 1.17 0 00-.826-2z"
        transform="translate(11.338 5)"
      />
    </svg>
  );
}

export default Caret;
